import React from "react";

import { URLS, SUPERVISOR_URL } from "configs/constants";
import Form from "components/Form";
import { useTranslation } from "react-i18next";

const SupervisorAssignmentViewDetails = () => {
  const initialValues = {
    employee_id: "",
    name: "",
    zone: "",
    region: "",
    estate: "",
    division: "",
    block: "",
    supervisor: "",
    worker_group: "",
  };

  const formFields = [
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
    },
    {
      type: "renderonly",
      name: "name",
      label: "Worker Name",
      key: "name",
    },
    {
      type: "renderonly",
      name: "company_name",
      key: "company_name",
      label: "Zone",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
    },
    {
      type: "renderonly",
      name: "zone_code_name",
      key: "zone_code_name",
      label: "Company",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
    },
    {
      type: "renderonly",
      name: "region_code_name",
      key: "region_code_name",
      label: "Region",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
    },
    {
      type: "renderonly",
      name: "estate_code_name",
      key: "estate_code_name",
      label: "Estate",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
    },
    {
      type: "renderonly",
      name: "division_code_name",
      key: "division_code_name",
      label: "Division",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
    },
    {
      type: "renderonly",
      name: "block_code_name",
      key: "block_code_name",
      label: "Block",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
    },
    {
      type: "renderonly",
      name: "supervisor_code_name",
      key: "supervisor_code_name",
      label: "Supervisor",
    },
    {
      type: "renderonly",
      name: "worker_group_code_name",
      key: "worker_group_code_name",
      label: "Worker Group",
    },
  ];
  const { t } = useTranslation();
  const formButtons = [
  
    "cancel",
  ];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={SUPERVISOR_URL}
      listRoute={URLS.SUPERVISOR_ASSIGNMENT_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Assign Supervisor/Worker Group"
    />
  );
};

export default SupervisorAssignmentViewDetails;
